import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';

export const stormPointMetadata = {
  id: 'storm-point',
  name: 'Storm Point',
  description:
    'A raw, storm-exposed headland of cliff-edge targets, wind-bent vegetation and almost no shelter.',
  environmentPreset: 'storm-headland',
  metadata: {
    location: 'Tempest Headland',
    regionType: 'coastal',
    difficulty: 91,
    typicalWind: [12, 24] as const,
    greenSpeed: [11, 11.5] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Trajectory and cliffside risk management in powerful crosswinds',
    signatureHoles: [3, 7, 13, 18],
    tournamentEventId: 'event-17',
    previewTheme: 'storm-headland',
    environmentPalette: {
      fairway: '#53664f',
      rough: '#39483c',
      bunker: '#a69b83',
      water: '#243f53',
      haze: '#59636c',
      sky: '#303943',
      rock: '#41474b',
    },
    vegetationStyle: 'low wind-bent coastal scrub',
    terrainStyle: terrainPreset('storm-headland', 30, 105, 1.35).id,
    sunlightDirection: 'broken light beneath storm clouds',
    distantScenery: 'black cliffs and violent open ocean',
    waterStyle: 'slate storm sea',
    eventPresentation: {
      accentColor: '#6e8290',
      mark: 'STORM POINT',
      subtitle: 'No shelter. Control the flight.',
      loadingCopy: 'The headland wind is rising',
      identityLine: 'The tour’s rawest exposed coastal test',
      tierLabel: 'SIGNATURE · NO CUT',
    },
  },
};
const pars = [4, 4, 3, 4, 5, 4, 4, 3, 4, 4, 3, 4, 5, 4, 3, 4, 5, 4];
const yards = [
  430, 445, 165, 455, 570, 420, 315, 205, 450, 440, 185, 465, 600, 425, 195, 445, 575, 470,
];
const names = [
  'First Squall',
  'Shelter Lost',
  'Cliff Needle',
  'Black Shelf',
  'Turning Gale',
  'Rain Line',
  'The Dare',
  'Sea Wall',
  'Outer Point',
  'Cross Sea',
  'Gannet',
  'High Exposure',
  'Three Winds',
  'Inland Mercy',
  'White Water',
  'Storm Gate',
  'Compass',
  'Last Headland',
];
const options: Partial<HolePlan>[] = [];
options[2] = { water: 'green', rocks: 6, trees: 0, bunkerCount: 2 };
options[6] = { water: 'right', splitFairway: true, rocks: 5, trees: 0 };
options[12] = { dogleg: 'double', water: 'left', rocks: 6, trees: 0 };
options[17] = {
  water: 'right',
  rocks: 8,
  trees: 0,
  landingZones: [{ distance: 285, width: 32, preferredSide: 'left' }],
};
export const createStormPointDocument = () =>
  authorCourse({
    ...stormPointMetadata,
    plans: plans(names, pars, yards, options).map((p) => ({
      ...p,
      trees: p.trees ?? 1,
      rocks: p.rocks ?? 3,
    })),
  });
